import i18n from 'asset/translation';
import { TextInputFieldData } from 'adapter/in/common/form/types';

export const validationIsHexColor = (value: TextInputFieldData): boolean | string =>
    new RegExp('^#([0-9a-fA-F]{3}){1,2}$').test(value.value) || i18n.t('widgets.errorInvalidColor').toString();

export const validationIsNumber = (value: TextInputFieldData): boolean | string =>
    (value.value.trim().length > 0 && !Number.isNaN(Number(value.value))) || i18n.t('widgets.errorNotNumber').toString();

export const validationMinValue = (min: number) => (value: TextInputFieldData): boolean | string =>
    Number(value.value) >= min || i18n.t('widgets.errorMinValue', { min }).toString();

export const validationMaxValue = (max: number) => (value: TextInputFieldData): boolean | string =>
    Number(value.value) <= max || i18n.t('widgets.errorMaxValue', { max }).toString();

export const validationGreaterThan = (compareValue: number, compareLabel: string) => (value: TextInputFieldData): boolean | string =>
    compareValue < Number(value.value) ||
    i18n
        .t('widgets.errorGreaterThanOther', {
            first: i18n.t(compareLabel),
        })
        .toString();

export const fromOutsideRange = (value: number, startRange: number, endRange: number): boolean => value < startRange || value >= endRange;
export const toOutsideRange = (value: number, startRange: number, endRange: number): boolean => value > endRange || value <= startRange;

type RangePairValue = {
    key: number;
    from: TextInputFieldData;
    to: TextInputFieldData;
};
export const validationIntersectionRanges = (values: RangePairValue[], index: number) => (): boolean | string => {
    if (values.length === 0) return true;
    const indexValue = values.filter((value) => value.key === index);
    const fromIndexValue = indexValue[0].from;
    const toIndexValue = indexValue[0].to;
    const fromToAreNotNumbers =
        typeof validationIsNumber(fromIndexValue) === 'string' || typeof validationIsNumber(toIndexValue) === 'string';
    if (fromToAreNotNumbers) return true;
    const rangesContainers = values
        .filter((value) => value.key !== index)
        .filter(
            (value) =>
                validationIsNumber(value.from) &&
                validationIsNumber(value.to) &&
                (!fromOutsideRange(Number(fromIndexValue.value), Number(value.from.value), Number(value.to.value)) ||
                    !toOutsideRange(Number(toIndexValue.value), Number(value.from.value), Number(value.to.value)))
        );
    return rangesContainers.length === 0 || i18n.t('widgets.widgetMenu.ranges.errorContainedInRange').toString();
};
